import Footer from "./footer.molecule";

export default Footer;
